var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-corners-goals"},[(_vm.isMobile)?_c('StatisticsCornersGoalsMobile',{attrs:{"data-by-period":_vm.dataByPeriod}}):_c('StatisticsCornersGoalsDesktop',{attrs:{"data-by-period":_vm.dataByPeriod,"is-corners":this.type === 'corners'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }